





















import { Component, Vue } from "vue-property-decorator";
import { BIcon, BIconArrowRight} from "bootstrap-vue";
@Component({
  components: {
    BIcon,
    BIconArrowRight
  }
})
export default class ShareTheory extends Vue {}
